import React from 'react'

export function IconTextoAlignComponent({ fill = '#2F5DC9', height = '17', width = '17' }: { fill?: string, height?: string, width?: string }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5H20V7H4V5ZM4 9H20V11H4V9ZM4 13H20V15H4V13ZM4 17H14V19H4V17Z" fill={fill} />
    </svg>
  )
}
